import React, { useEffect, useRef, useState } from "react";
import { Canvas, Path, PencilBrush, FabricImage, IText, Rect, Circle, Line, util } from "fabric";
import WhiteboardToolbar from './WhiteboardToolbar';
import api from '../services/api';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';


const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const token = localStorage.getItem('token');

const Whiteboard = ({ socket, prompt, discussionId, discussionName, userId, onClose, initialWhiteboardId }) => {
  const { t } = useTranslation();
  const canvasRef = useRef(null);
  const fabricCanvasRef = useRef(null);
  const [whiteboardList, setWhiteboardList] = useState([]);
  const [currentId, setCurrentId] = useState(null);
  const [currentName, setCurrentName] = useState(t('tableau.initial'));
  const historyRef = useRef([]);
  const [visibility, setVisibility] = useState('shared');
  const [currentCreatedBy, setCurrentCreatedBy] = useState(null);
const [createur, setCreateur] = useState(null);
//const [creatorName, setCreatorName] = useState(null);
const [creator, setCreator] = useState(null);
const isRestoringRef = useRef(false);
  
const handleNewWhiteboard = () => {
  setCreator(null);
    // Autres logiques pour créer un nouveau tableau
};
  const loadList = async () => {
  try {
    const response = await api.get(`${API_URL}/api/whiteboards/list/${discussionId}?userId=${userId}`,
{ headers: { Authorization: `Bearer ${token}` } }
);
    setWhiteboardList(response.data);
  } catch (error) {
    console.error("Erreur chargement liste :", error);
  }
};

  const setEraserMode = () => {
    if (!fabricCanvasRef.current) return;
    fabricCanvasRef.current.isDrawingMode = true;
    fabricCanvasRef.current.freeDrawingBrush = new PencilBrush(fabricCanvasRef.current);
    fabricCanvasRef.current.freeDrawingBrush.width = 20;
    fabricCanvasRef.current.freeDrawingBrush.color = "#ffffff";
  };

  const setPencilMode = (color = "#000000", size) => {
  if (!fabricCanvasRef.current) return;
  fabricCanvasRef.current.isDrawingMode = true;

  // Crée le brush seulement s'il n'existe pas encore
  if (!fabricCanvasRef.current.freeDrawingBrush) {
    fabricCanvasRef.current.freeDrawingBrush = new PencilBrush(fabricCanvasRef.current);
  }

  fabricCanvasRef.current.freeDrawingBrush.color = color;

  // Met à jour la taille seulement si explicitement passée
  if (size !== undefined) {
    fabricCanvasRef.current.freeDrawingBrush.width = size;
  }
};

// Fonction utilitaire — sauvegarde l'état courant dans l'historique
const saveToHistory = () => {
  if (isRestoringRef.current) return;

  historyRef.current.push(
    JSON.stringify(
      fabricCanvasRef.current.toJSON(['src', 'id'])
    )
  );

  if (historyRef.current.length > 20) {
    historyRef.current.shift();
  }
};

  const loadWhiteboard = async (id) => {
  if (!id) return;
  try {
    const response = await api.get(`${API_URL}/api/whiteboards/${id}`,
{ headers: { Authorization: `Bearer ${token}` } }
);
    let canvasData = response.data?.data;
    if (typeof canvasData === "string") canvasData = JSON.parse(canvasData);
    fabricCanvasRef.current.clear();
    if (canvasData && Object.keys(canvasData).length > 0) {
      await fabricCanvasRef.current.loadFromJSON(canvasData);
      fabricCanvasRef.current.renderAll();
    }
    historyRef.current = [];
    saveToHistory();
    setCurrentId(id);
    setCurrentName(response.data?.name || "Sans titre");
setCreateur(response.data?.creatorName);
//setCreatorName(response.data?.creatorName);
    setVisibility(response.data?.visibility || 'shared'); // ← restaure la visibility
  } catch (error) {
    console.error("Erreur chargement tableau :", error);
  }
};

  const newWhiteboard = () => {
    fabricCanvasRef.current.clear();
    fabricCanvasRef.current.backgroundColor = "#ffffff";
    fabricCanvasRef.current.renderAll();
    historyRef.current = []; // ← remet l'historique à zéro
	saveToHistory();
    setCurrentId(null);
    setCurrentName("Sans titre");
setCurrentCreatedBy(userId);
  };


  const loadImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
const { alert } = prompt;

  // ← vérification du poids original (limite : 50MB)
  if (file.size > 10 * 1024 * 1024) {
    alert("❌ t('tableau.size')");
    e.target.value = ""; // ← reset l'input
    return;
  }
    const reader = new FileReader();
    reader.onload = async (event) => {
      const htmlImg = new Image();
      htmlImg.onload = async () => {
        const compressCanvas = document.createElement('canvas');
        const maxSize = 800;
        const scale = Math.min(maxSize / htmlImg.width, maxSize / htmlImg.height, 1);
        compressCanvas.width = htmlImg.width * scale;
        compressCanvas.height = htmlImg.height * scale;
        compressCanvas.getContext('2d').drawImage(htmlImg, 0, 0, compressCanvas.width, compressCanvas.height);
        const compressed = compressCanvas.toDataURL('image/jpeg', 0.7);

// ← vérification après compression (limite : 2MB en base64)
      const compressedSize = (compressed.length * 3) / 4; // ← estimation bytes depuis base64
      if (compressedSize > 2 * 1024 * 1024) {
        await alert("❌ t('tableau.sizecompress')");
        e.target.value = "";
        return;
      }

        const img = await FabricImage.fromURL(compressed);
        const canvasWidth = fabricCanvasRef.current.getWidth();
        const canvasHeight = fabricCanvasRef.current.getHeight();
        const scaleX = canvasWidth / img.width;
        const scaleY = canvasHeight / img.height;
        const imgScale = Math.min(scaleX, scaleY) * 0.9;

        img.set({
          scaleX: imgScale,
          scaleY: imgScale,
          left: (canvasWidth - img.width * imgScale) / 2,
          top: (canvasHeight - img.height * imgScale) / 2,
          selectable: true,
          originX: 'left',
          originY: 'top',
        });

        fabricCanvasRef.current.add(img);
        fabricCanvasRef.current.setActiveObject(img);
        fabricCanvasRef.current.renderAll();
	saveToHistory();
// ← diffuse l'état complet aux autres
const canvasJSON = JSON.stringify(fabricCanvasRef.current.toJSON(['src', 'id']));
socket.emit("whiteboard-sync", {
  discussionId,
  userId,
  canvasJSON,
});

        // ← sauvegarde dans l'historique après ajout image
        historyRef.current.push(JSON.stringify(fabricCanvasRef.current.toJSON(['src', 'id'])));
        if (historyRef.current.length > 20) historyRef.current.shift();
      };
      htmlImg.src = event.target.result;
    };
    reader.readAsDataURL(file);
  };

  const saveWhiteboard = async () => {
  const data = fabricCanvasRef.current.toObject(['src', 'crossOrigin']);
  const { confirm, alert, input } = prompt;
  const name = await input(t('tableau.name'), currentName);
  if (!name) return;
  const confirmed = await confirm(t('tableau.save', { name }));
  if (!confirmed) return;
  try {
    if (currentId) {
      await api.put(`${API_URL}/api/whiteboards/${currentId}`,
        { data, name, visibility, userId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } else {
      const response = await api.post(`${API_URL}/api/whiteboards`,
        { discussionId, data, name, visibility, createdBy: userId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCurrentId(response.data._id);
    }
    setCurrentName(name);
    loadList();
    socket.emit("whiteboard-list-updated", { discussionId });
    await alert(t('tableau.saved'));
  } catch (error) {
if (error.response?.status === 403) {
    alert(t('tableau.visibilityChangeForbidden'));
    return;
  }
else {
    console.error("Erreur sauvegarde :", error);
    await alert(t('tableau.errorsaved'));
}
  }
};

  const deleteWhiteboard = async () => {
  const { confirm, alert } = prompt;
  if (!currentId) {
    await alert(t('tableau.nonsaved'));
    return;
  }
  const confirmed = await confirm(t('tableau.delete', { currentName }));
  if (!confirmed) return;
  try {
    await api.delete(`${API_URL}/api/whiteboards/${currentId}?userId=${userId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    newWhiteboard();
    loadList();
    socket.emit("whiteboard-list-updated", { discussionId });
    await alert(t('tableau.deleted'));
  } catch (error) {
    // ← gère le 403
    if (error.response?.status === 403) {
      await alert(t('tableau.onlyOwnerCanSup'));
    } else {
      await alert(t('tableau.errordeleted'));
    }
  }
};

  const undo = async () => {
  if (historyRef.current.length <= 1) return;

  isRestoringRef.current = true;

  historyRef.current.pop();

  const previous =
    historyRef.current[historyRef.current.length - 1];

  fabricCanvasRef.current.clear();

  if (previous) {
    await fabricCanvasRef.current.loadFromJSON(
      JSON.parse(previous)
    );
  }

  fabricCanvasRef.current.backgroundColor = "#ffffff";
  fabricCanvasRef.current.renderAll();

  socket.emit("whiteboard-sync", {
    discussionId,
    userId,
    canvasJSON: previous || null,
  });

  requestAnimationFrame(() => {
    isRestoringRef.current = false;
  });
};

  useEffect(() => {
    if (!socket) return;

    fabricCanvasRef.current = new Canvas(canvasRef.current, {
      isDrawingMode: true,
      width: 800,
      height: 600,
      backgroundColor: "#ffffff",
    });
    fabricCanvasRef.current.freeDrawingBrush = new PencilBrush(fabricCanvasRef.current);
    fabricCanvasRef.current.freeDrawingBrush.width = 2;
    fabricCanvasRef.current.freeDrawingBrush.color = "#000000";
	historyRef.current = [];
	saveToHistory(); 

    // ← listeners de sélection ICI, pas dans socket.on("drawing")
    fabricCanvasRef.current.on("selection:created", () => {
      fabricCanvasRef.current.isDrawingMode = false;
    });
    fabricCanvasRef.current.on("selection:cleared", () => {
      fabricCanvasRef.current.isDrawingMode = true;
    });

    fabricCanvasRef.current.on("path:created", (event) => {
      saveToHistory();
      const path = event.path;
if (!path.id) {
    path.id = crypto.randomUUID();
  }
      socket.emit("drawing", {
        discussionId,
        userId,
        path: path.path,
        options: {
	id: path.id,
          stroke: path.stroke,
          strokeWidth: path.strokeWidth,
          fill: path.fill || "transparent",
          strokeLineCap: path.strokeLineCap,
          strokeLineJoin: path.strokeLineJoin,
        },
      });
    });
	fabricCanvasRef.current.on("object:added", (e) => { 


  const obj = e.target;

  if (!obj) return;

  // IMPORTANT
  if (obj.__fromRemote) return;



  if (!obj.id) {
    obj.id = crypto.randomUUID();
  }

if (
  obj.type === "rect" ||
  obj.type === "circle" ||
  obj.type === "line" ||
  obj.type === "path"
) {
  return;
}

  socket.emit("object:added", {
    discussionId,
    userId,
    object: obj.toObject(['id', 'src']),
  });
 


});

fabricCanvasRef.current.on("object:modified", (e) => {
  if (e.target?.__fromRemote) return;
saveToHistory();
  const obj = e.target;
  if (!obj) return;
 
  socket.emit("object:modified", {
    discussionId,
    userId,
    object: obj.toObject(['src', 'id']),
  });

});
fabricCanvasRef.current.on("object:removed", (e) => {

  const obj = e.target;

  if (!obj || obj.__fromRemote) return;
 saveToHistory();
  socket.emit("object:removed", {
    discussionId,
    userId,
    objectId: obj.id,
  });
});
    socket.on("drawing", (data) => {
      if (data.userId !== userId) {
        const fabricPath = new Path(data.path, {
          ...data.options,
          selectable: true,
          evented: true,
        });
	  fabricPath.id = data.options.id;
        fabricCanvasRef.current.add(fabricPath);
        fabricCanvasRef.current.renderAll();
      }
    });

socket.on("whiteboard-sync", async (data) => {
  if (data.userId !== userId) { // ← ignore ses propres émissions
    fabricCanvasRef.current.clear();
    if (data.canvasJSON) {
      await fabricCanvasRef.current.loadFromJSON(JSON.parse(data.canvasJSON));

    }
    fabricCanvasRef.current.backgroundColor = "#ffffff";
    fabricCanvasRef.current.renderAll();

//fabricCanvasRef.current.skipTargetFind = false;
//fabricCanvasRef.current.selection = true;

  }

historyRef.current = [
  JSON.stringify(fabricCanvasRef.current.toJSON(['src', 'id']))
];
});
socket.on("object:removed", (data) => {
  if (data.userId === userId) return;

  const canvas = fabricCanvasRef.current;

  const obj = canvas.getObjects().find(o => o.id === data.objectId);

  if (obj) {
    obj.__fromRemote = true;
    canvas.remove(obj);
    canvas.renderAll();
  }
});
socket.on("object:added", async (data) => {
  if (data.userId === userId) return;

  const obj = await util.enlivenObjects([data.object]);

  const fabricObj = obj[0];

  if (!fabricObj) return;

  fabricObj.__fromRemote = true;
  fabricObj.set("id", data.object.id);

  fabricCanvasRef.current.add(fabricObj);
  fabricCanvasRef.current.renderAll();

  requestAnimationFrame(() => {
    fabricObj.__fromRemote = false;
  });
});

socket.on("object:modified", (data) => {
  if (data.userId === userId) return;

  const canvas = fabricCanvasRef.current;

  const existing = canvas
    .getObjects()
    .find(o => o.id === data.object.id);

  if (!existing) return;

  existing.__fromRemote = true;

  // clone propre
  const updates = { ...data.object };

  // propriétés Fabric readonly/interdites
  delete updates.type;
  delete updates.version;
  delete updates.objects;

  existing.set(updates);

  existing.setCoords();

  canvas.renderAll();

  requestAnimationFrame(() => {
    existing.__fromRemote = false;
  });
});

socket.on("whiteboard-list-updated", () => {
  loadList(); // ← recharge la liste chez tous les participants
});
    socket.on("clear-whiteboard", () => {
      fabricCanvasRef.current.clear();
      fabricCanvasRef.current.backgroundColor = "#ffffff";
      fabricCanvasRef.current.renderAll();
    });

    const handleKeyDown = (e) => {
      if ((e.key === 'Delete' || e.key === 'Backspace') &&
        !e.target.matches('input, textarea')) {
        const activeObject = fabricCanvasRef.current.getActiveObject();
        if (activeObject) {
          fabricCanvasRef.current.remove(activeObject);
          fabricCanvasRef.current.discardActiveObject();
          fabricCanvasRef.current.renderAll();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    // ← charge le tableau initial si fourni
    if (initialWhiteboardId) {
      loadWhiteboard(initialWhiteboardId);
    } else {
      loadList();
    }
    socket.emit("join-whiteboard", { discussionId, userId });

    return () => {
      socket.off("drawing");
      socket.off("clear-whiteboard");
	socket.off("whiteboard-sync");
	socket.off("whiteboard-list-updated");
	socket.off("object:added");
	socket.off("object:modified");
	socket.off("object:removed");
      window.removeEventListener('keydown', handleKeyDown);
      fabricCanvasRef.current?.dispose();
    };
  }, [discussionId, userId, socket]);

// ← charge aussi la liste dans tous les cas
  useEffect(() => {
    if (discussionId) loadList();
  }, [discussionId]);

  if (!socket) return <div>Connexion en cours...</div>;

  return (
    <div className="whiteboard-container" style={{ display: 'flex', flexDirection: 'column', flex: 1, padding: '8px', zIndex: 5000 }}>
      <WhiteboardToolbar
        canvasRef={fabricCanvasRef}
        socket={socket}
        discussionId={discussionId}
	discussionName={discussionName}
	visibility={visibility}
  	onSetVisibility={setVisibility}
  	createdBy={currentCreatedBy} 
	createur={createur}
	setCreateur={setCreateur}
	//creatorName={creatorName}
	userId={userId}
        whiteboardList={whiteboardList}
        currentName={currentName}
        onSelect={loadWhiteboard}
        onNew={newWhiteboard}
        onSave={saveWhiteboard}
        onDelete={deleteWhiteboard}
        loadImage={loadImage}
        onSetEraser={setEraserMode}
        onSetPencil={setPencilMode}
        onUndo={undo}
	onClose={onClose}
	prompt={prompt}
      />
      <canvas ref={canvasRef} style={{ display: 'block', border: '1px solid #ccc' }} />
    </div>
  );
};

export default Whiteboard;